import { useMutation, useQuery } from '@tanstack/react-query'
import services from './auth-services'
import { MinorsTermFormData } from './components/MinorsTermModal/types'
import { AppointmentConfirmationParams } from './types/en-us'

export const useSend2FACode = (enabled: boolean) => {
  return useQuery({
    queryKey: ['send-2fa'],
    queryFn: async () => {
      return await services.sendTwoFactorAuthCode()
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled,
  })
}

export const useValidate2FACode = (code: string) => {
  return useQuery({
    queryKey: ['validate-2fa'],
    queryFn: async () => {
      return await services.validateTwoFactorAuthCode(code)
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: false,
  })
}

export const useSendMinorsTermData = () => {
  return useMutation({
    mutationFn: (data: MinorsTermFormData) =>
      services.sendMinorsGuardianData(data),
  })
}

export const useConfirmAppointment = (data: AppointmentConfirmationParams) => {
  return useQuery({
    queryKey: ['confirm-appointment', data],
    queryFn: async () => await services.confirmAppointment(data),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!(data?.attendanceToken && data?.userToken),
  })
}
